/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * The possible options for preferences for sending email notifications.
 */
export const EmailNotificationTypes = /* #__PURE__ */ parsers.exactly('direct', 'daily', 'weekly', 'off');
